function setCookie(name, value, days){
  var days = days; 
  var name = name;
  var value = value;
  var date = new Date();
  date.setTime(date.getTime()+(days*24*60*60*1000));
  var expires = days ? "; expires="+date.toGMTString() : '';
  document.cookie = name+"="+value+';'+expires+"; path=/";
};

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
};